import { render, staticRenderFns } from "./contact.html?vue&type=template&id=48f0b276&scoped=true&"
import script from "./contact.js?vue&type=script&lang=js&"
export * from "./contact.js?vue&type=script&lang=js&"
import style0 from "./contact.scss?vue&type=style&index=0&id=48f0b276&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f0b276",
  null
  
)

export default component.exports